import { render, staticRenderFns } from "./FormulatePhoneNumber.vue?vue&type=template&id=05b8f29a"
import script from "./FormulatePhoneNumber.vue?vue&type=script&lang=js"
export * from "./FormulatePhoneNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports